<div class="row">
  <div class="col-12">
    <app-label label="Geometria:">
      {{ application?.geometry ? 'Tak' : 'Nie' }}
    </app-label>
  </div>
</div>
<div class='row'>
  <div class='col-md-4'>
    <app-label label='Numer drogi:'>
      {{ application?.roadNumber || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Nazwa drogi:'>
      {{ application?.roadName || '-' }}
    </app-label>
  </div>
  <div class='col-md-6'>
    <app-label label='Ulica:'>
      {{ application?.street || '-' }}
    </app-label>
  </div>
</div>
<br>
<dl class="mb-5">
  <dt class="mb-3">
    <strong>
      {{ application | locationReconstructionOfExitApplicationParcelsSectionTitle }}
    </strong>
  </dt>
  <dd>
    <app-parcels-preview [parcels]="parcels || []"></app-parcels-preview>
  </dd>
</dl>
<br>
<dl class="mb-5">
  <dt class="mb-3">
    <strong>
      {{ application | locationReconstructionOfExitApplicationParcels2SectionTitle }}
    </strong>
  </dt>
  <dd>
    <app-parcels-preview [parcels]="parcels2 || []"></app-parcels-preview>
  </dd>
</dl>
<br>
<div><strong>Informacje o nieruchomości</strong></div>
<br>
<div class="row">
  <div class="col-12">
    <app-label label="Tytuł prawny do nieruchomości:">
      {{ application?.propertyLegalTitleDesc || application?.propertyLegalTitle?.name || '-' }}
    </app-label>
  </div>
</div>
<br>
<div class="row">
  <div class="col-md-6">
    <app-label label='Obecny sposób wykorzystania nieruchomości:'>
      {{ application?.propertyUsagePurposeText || application?.propertyUsagePurpose || '-' }}
    </app-label>
  </div>
  <div class="col-md-6">
    @if (application?.propertyUsagePurpose) {
      <div class="row">
        <div class="col-12">
          <app-label label='Sposób wykorzystania nieruchomości po wybudowaniu zjazdu:'>
            {{ application?.postInvestmentUsage || '-' }}
          </app-label>
        </div>
        @if (application?.postInvestmentUsage === 'Ulegnie zmianie na inny cel') {
          <div class="col-12">
            <app-label label='Zmiana wykorzystania nieruchomości:'>
              {{ application?.propertyUsageChange || '-' }}
            </app-label>
          </div>
        }
      </div>
    }
  </div>
</div>
<br>
<div class="row">
  @if (application?.referenceVehicleType; as referenceVehicleType) {
    <div class="col-12">
      <app-label label="Rodzaj pojazdu miarodajnego, który będzie obsługiwał zjazd:">{{ referenceVehicleType }}
      </app-label>
    </div>
  }
  @if (application?.propertyParkingSpacesCount; as propertyParkingSpacesCount) {
    <div class="col-12">
      <app-label
        label="Liczba stanowisk postojowych na terenie nieruchomości do której prowadził będzie zjazd:">{{ propertyParkingSpacesCount }}
      </app-label>
    </div>
  }
</div>
